import mutations from '@/store/modules/mobile/kpis/kpis.mutations';
import { NAV_TAB_KPI_USAGE } from '@/components/Mobile/mobile.constants';
import actions from '@/store/modules/mobile/kpis/kpis.actions';

import getters from '@/store/modules/mobile/kpis/kpis.getters';

export interface State {
  currentEventMessage: string;
  currentCrashID: string;
  currentPerformanceID: string;
  currentHttpReqName: string;
  currCountryName: string;
  currCountryCode: string;
  currPerfErrEventID: string;
}

const initialState: State = {
  currentEventMessage: '',
  currentCrashID: '',
  currentPerformanceID: '',
  currentHttpReqName: '',
  currCountryName: '',
  currCountryCode: '',
  currPerfErrEventID: ''
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions,
  getters
};
